import classnames from 'classnames'
import React from 'react'

import {
  checkIcon,
  iconCounterargument,
  iconEvidence,
  iconReasoning
} from 'modules/ui/assets'
import enhance from './enhancers'

export function Parts(props) {
  const { parts, selected, theme, handleSelect } = props

  return (
    <div className={theme.parts}>
      {parts.map((part, index) =>
        <Part
            evidence={part.evidence}
            focused={!selected && index === 0}
            key={index}
            selected={index === selected}
            theme={theme}
            onSelect={handleSelect(index)} />
      )}
    </div>
  )
}

function Part({ evidence, focused, selected, theme, onSelect }) {
  const classname = classnames(theme.part, {
    [theme.focused]: selected || focused,
    [theme.selected]: selected
  })

  return (
    <div className={classname} onClick={onSelect}>
      <div>
        <div className={theme.icons}>
          <img
              alt='counterargument icon'
              className={theme.counterargumentIcon}
              src={iconCounterargument} />

          <img
              alt='reasoning icon'
              className={theme.reasoningIcon}
              src={iconReasoning} />

          <img
              alt='evidence icon'
              className={theme.evidenceIcon}
              src={iconEvidence} />
        </div>

        <p className={theme.evidence}>
          {evidence}
        </p>
      </div>

      <div className={theme.check}>
        <img alt='check icon' src={checkIcon} />
      </div>
    </div>
  )
}

export default enhance(Parts)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Parts/index.js